<div class="modal-body" style="background-color:rgb(242, 242, 242);">
    <div class="container-fluid">
        <div class="row">
            <div class="col">
                <img src="{{imageLink}}" style="max-width:100%;
                max-height:100%; height: auto;">
            </div>
        </div>
    </div>
</div>